import { render } from "./SignUp.vue?vue&type=template&id=44d749bb"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"
script.render = render

export default script